import { Visual } from 'data/generated/graphql';

export const DEFAULT_GRAPHIC_LINKED_ITEM_ZONE = 'M';
export const DEFAULT_LINKED_ITEM_ZONE = 'S';

export const DEFAULT_MOBILE_LINKED_ITEM_ATTRIBUTES = {
  showFlashline: false,
  size: 'S',
  treatment: 'STANDARD_NEWS',
  visual: 'hidden'
};

export const DEFAULT_GRAPHIC_LINKED_ITEM_ATTRIBUTES = {
  type: 'link',
  visual: Visual.Primary,
  size: 'M',
  title: '',
  description: ''
};

export const BLOCKED_DOMAIN_PRODUCT_MAP: Record<string, string> = {
  'polymarket.com': 'polymarket'
};

export const BLOCKED_DOMAIN_TITLE_MAP: Record<string, string> = {
  'polymarket.com': 'Featured Prediction Market'
};

export const DISABLE_METADATA_DOMAINS = Object.keys(BLOCKED_DOMAIN_PRODUCT_MAP);

export const hasBlockedDomain = (url: string): boolean => {
  try {
    const { hostname } = new URL(url);
    return DISABLE_METADATA_DOMAINS.some((domain) => hostname === domain || hostname.endsWith(`.${domain}`));
  } catch {
    return false;
  }
};

export const getProductForUrl = (url: string): string => {
  try {
    const { hostname } = new URL(url);
    const matched = DISABLE_METADATA_DOMAINS.find((domain) => hostname === domain || hostname.endsWith(`.${domain}`));
    return matched ? BLOCKED_DOMAIN_PRODUCT_MAP[matched] : '';
  } catch {
    return '';
  }
};

export const getTitleForUrl = (url: string): string => {
  try {
    const { hostname } = new URL(url);
    const matched = DISABLE_METADATA_DOMAINS.find((domain) => hostname === domain || hostname.endsWith(`.${domain}`));
    return matched ? BLOCKED_DOMAIN_TITLE_MAP[matched] : '';
  } catch {
    return '';
  }
};

export const getLinkedItemTitle = (title: string | null | undefined, id: string): string => {
  if (title) return title;
  return getTitleForUrl(id) || id;
};
